import React from 'react';

type InputType = 'text' | 'email' | 'url' | 'password' | 'number' | 'search' | 'tel';

export type InputProps = {
  name: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  error?: boolean;
  validator?: any;
  type?: InputType;
  [x: string]: any;
};

function Input({ className, type, name, error, onChange, validator, ...props }: InputProps) {
  return (
    <div className="relative">
      {validator}
      <input
        {...props}
        className={`${className} ${
          error ? '!border-river-red focus:!ring-river-red' : ''
        } disabled:border-[#dfe5eb] disabled:bg-[#F9F9F9]`}
        name={name}
        type={type}
        aria-label={name}
        onChange={onChange}
      />
    </div>
  );
}

Input.defaultProps = {
  type: 'text',
};

export default Input;
